var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
// import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
// import App from './App';
import Loading from './components/common/Loading';
import { store } from './redux/store';
import './assets/css/vendor/bootstrap/v4.1.0/bootstrap.min.css';
import './assets/css/vendor/bootstrap/v4.1.0/bootstrap.rtl.only.min.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
// import 'react-table-v6/react-table.css';
import './index.css';
import '@tratum/ui/src/styles.css';
import './assets/css/sass/themes/gogo.light.blue.scss';
// import * as serviceWorker from './serviceWorker';
// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );
var App = lazy(function () { return import('./App'); });
if (window.location.hostname.includes('audiflix')) {
    window.location.assign('https://dash.tratum.com.br');
}
ReactDOM.render(_jsx(Provider, __assign({ store: store }, { children: _jsx(Suspense, __assign({ fallback: _jsx(Loading, {}) }, { children: _jsx(App, {}) })) })), document.getElementById('root'));
